import { ChangeDetectorRef, Component, NgZone, OnInit, ViewChild} from '@angular/core';
import { finalize } from 'rxjs/operators';
import { UtilService } from '../service/util.service';
import { MatDialog } from '@angular/material/dialog';
import { BookSelectedSlotsComponent } from '../book-selected-slots/book-selected-slots.component';
import { AuthService } from '../service/auth.service';
import { AppConstants } from '../AppConstants';
import { Subscription } from 'rxjs';
import { AdminBookingsService } from '../service/admin-bookings.service';
import { ActivatedRoute } from '@angular/router';
import { ShowNotificationComponent } from '../show-notification/show-notification.component';
import { DatePipe, DOCUMENT } from '@angular/common';
import { FormsModule, FormControl, Validators, FormGroup, FormGroupDirective, NgForm, FormBuilder } from '@angular/forms';
import { formatDate } from '@angular/common';
import { BulkBookingsComponent } from '../bulk-bookings/bulk-bookings.component';

interface TimeSlot {
  id: number;
  venueId: number;
  tenantId: number;
  startTime: string;
  endTime: string;
  price: number;
  productId: number;
  sessionId: number;
  createdAt?: string;
  updatedAt?: string;
}

interface SessionWithSlots {
  id: number;
  tenantId: number;
  productId: number;
  startTime: string;
  endTime: string;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  isDisabled: boolean;
  createdAt?: string;
  updatedAt?: string;
  timeslots: TimeSlot[];
}

interface ProductWithSlots {
  id: number;
  name: string;
  type: string;
  durationPerSlot: number;
  sessionType?: string;
  noOfSessions?: number;
  monthlyMultiBookingOption?: boolean;
  monthlyMultiBookingSelectedDates?: string[];
  capacityPerVenue: number;
  price: number;
  description?: string;
  sessions: SessionWithSlots[];
  timeslots: TimeSlot[];
}
interface MonthlySlotData {
uniqueId: string;
productId:number;
productName: string;
venueName: string;
price: number;
date: string;
startTime: string;
endTime: string;

}


@Component({
  selector: 'app-admin-bookings',
  templateUrl: './admin-bookings.component.html',
  styleUrls: ['./admin-bookings.component.css'],
  providers: [DatePipe]
})
export class AdminBookingsComponent implements OnInit {
  readonly MAX_ADD_ON_QUANTITY = 99;
  addOnQuantities: { [productId: number]: number } = {};
  get selectedAddOnsMap() {
    return this.adminBookingSvc.selectedAddOns;
  }

  get addOnCartTotal(): number {
    return Math.round(this.adminBookingSvc.getSelectedAddOns().reduce((sum, item) => sum + item.quantity * item.unitPrice, 0) * 100) / 100;
  }
  addOnError = '';

  get isAddOnSelected(): boolean {
    return this.selectedProduct?.type === AppConstants.ADD_ONS;
  }

  getAddOnQuantity(): number {
    const productId = this.selectedProduct?.id;
    return this.addOnQuantities[productId] ?? this.selectedAddOnsMap.get(productId)?.quantity ?? 1;
  }

  changeAddOnQuantity(change: number): void {
    const quantity = Number(this.getAddOnQuantity());
    const current = Number.isFinite(quantity) ? Math.trunc(quantity) : 1;
    this.addOnQuantities[this.selectedProduct.id] = Math.min(this.MAX_ADD_ON_QUANTITY, Math.max(1, current + change));
    this.addOnError = '';
  }

  addSelectedAddOn(): void {
    if (!this.isAddOnSelected) return;
    const quantity = Number(this.getAddOnQuantity());
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > this.MAX_ADD_ON_QUANTITY) {
      this.addOnError = `Please enter a quantity between 1 and ${this.MAX_ADD_ON_QUANTITY}.`;
      return;
    }
    const unitPrice = Number(this.selectedProduct.price);
    if (!Number.isFinite(unitPrice) || unitPrice < 0) {
      this.addOnError = 'This add-on does not have a valid price.';
      return;
    }
    this.adminBookingSvc.setSelectedAddOn({
      tenantId: Number(this.user.tenantId), productId: this.selectedProduct.id,
      productName: this.selectedProduct.name, quantity, unitPrice, venueId: this.venues[0]?.id
    });
    this.addOnQuantities[this.selectedProduct.id] = quantity;
    this.addOnError = '';
  }

  removeSelectedAddOn(): void {
    this.adminBookingSvc.removeSelectedAddOn(this.selectedProduct.id);
    delete this.addOnQuantities[this.selectedProduct.id];
    this.addOnError = '';
  }

  selectedSlotPrice: number = 0;
  isLoading = true;

  selectedDateStr = this.getCurrentDate();
  selectedDate = new Date();
  venues = [];
  venuesOfSelectedProduct = [];
  products = [];
  preselectProductId: number = null;
  selectedProduct: any;
  selectedProductName: string;
  selectedVenueId: number | null = null;
  selectedServiceType: string; //
  selectedProductPrice: number;
  sessionType: string;
  TimeSlotsForSelectedMonthlyProduct: any;
  selectedTime: string[] = [];
  monthlyMultiBookingOption: string;
  monthlyMultiBookingSelectedDates: number[];
  futureDates: string[] = []; // Array to store generated future dates
  maxDate: any;
  minDate: any;
  toDate: any;
  selectedStartDate: string;
  latest_date1: any;

  venuesSubscription: any;
  productsSubscription: any;
  user: any;
  venuesForSelectedProduct = [];
  reloadDataSubscription: Subscription;
  showFullDay = false;
  showGroupVenueLayout: boolean = true;
  expiryInDays: string = '0';
  expiryInMin: string = '30';
  paymentMethod: string = 'cash';
  paymentOption: string = 'anytime';
  // Flexible booking, Cash method: "Paid" (Booked) or "WaitingForPayment". Values match the backend.
  cashPaymentStatus: string = 'Paid';
  tenantFees: any;
  productEditAddSessionChips: string[] = [
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
    'Sunday'
  ];


  constructor(private authService: AuthService,
    private dialog: MatDialog,
    private adminBookingSvc: AdminBookingsService,
    private changeDetect: ChangeDetectorRef,
    private datePipe: DatePipe,
    private route: ActivatedRoute,
    private utilService: UtilService,
    private ngZone: NgZone) {

    // Initialize latest_date1 with the current date
    this.latest_date1 = new Date().toISOString().split('T')[0];
    this.selectedStartDate = this.latest_date1;

    // Calculate the maximum allowable date (current date + 1 month)
    const maxDate = new Date();
    maxDate.setMonth(maxDate.getMonth() + 1);
    this.maxDate = maxDate.toISOString().split('T')[0];

  }
  @ViewChild('formRef') formRef : NgForm;
  selectedDays: string[] = [];
  bookingData = {
    startDate: '',
    months: 1,
    amount: 0,
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    notes: '',
    startTime: '',
    endTime: '',
    selectedDays: [],
    venue: ''
  };
  allTimes = [];

  bookNowDisabled = true; // start disabled

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT));

    // Product to preselect once products load (e.g. after returning from an admin Pay Now payment).
    const productIdParam = this.route.snapshot.queryParamMap.get('productId');
    this.preselectProductId = productIdParam ? Number(productIdParam) : null;

    // Returning from a successful admin Pay Now payment: show the same success popup as the cash flow.
    const confirmedBookingId = this.route.snapshot.queryParamMap.get('confirmationId');
    if (confirmedBookingId) {
      setTimeout(() => {
        this.dialog.open(ShowNotificationComponent, { data: confirmedBookingId });
      });
    }

    if (AppConstants.SESSION_STORAGE_ROLEID == 1) {
      console.log("Tenant Id Venues ", AppConstants.SESSION_STORAGE_TENANTID);
      this.user.tenantId = AppConstants.SESSION_STORAGE_TENANTID;
      console.log("Tenant Id ", this.user.tenantId);
      //console.log("user", this.user);
    }

    this.adminBookingSvc.setAddOnTenant(Number(this.user.tenantId));
    this.getAllVenuesByTenantId(this.user.tenantId);
    this.loadTenantFees(this.user.tenantId);

    this.reloadDataSubscription = this.adminBookingSvc.reloadData.subscribe((data: any) => {
      if (data.reloadData) {
        if (data.confirmationId) {
          this.dialog.open(ShowNotificationComponent, {
            data: data.confirmationId
          });
        } else if (data.cancelledSlot) {
          var snackbar = document.getElementById("snackbar");
          snackbar.className = "show";
          setTimeout(function () {
            snackbar.className = snackbar.className.replace("show", "");
          }, 3000); // Hide after 3 seconds
        }
      }
    });
  }

  convertTo24Hr(time: string): string {
    const [timePart, modifier] = time.split(' ');
    let [hours, minutes] = timePart.split(':').map(Number);

    if (modifier === 'PM' && hours !== 12) hours += 12;
    if (modifier === 'AM' && hours === 12) hours = 0;

    return `${hours}:${minutes.toString().padStart(2, '0')}`;
  }

  /* convertTo24Hour(time12h: string): string {
      const date = new Date("1970-01-01 " + time12h);
      const hours = date.getHours();   // 0–23
      const minutes = date.getMinutes();
      return `${hours}:${minutes.toString().padStart(2, "0")}`;
    } */
  onTimeRadioChange(time: string) {
    this.selectedTime = [time]; // always keep a single selection in the array

    const selectedSlot = this.selectedProduct?.timeslots?.find(slot =>
        this.formatTimeToAMPM(slot.startTime) === time
      );

      this.selectedSlotPrice =
        selectedSlot?.price ?? this.selectedProductPrice;

      console.log('Selected slot price:', this.selectedSlotPrice);
  }

  /** End user (platform) fee for a Flexible "Pay Now" booking. Mirrors the backend getBookingFee for a non-monthly slot. */
  getFlexiblePlatformFee(): number {
    if (this.paymentMethod !== 'payNow') {
      return 0;
    }
    const amount = Number(this.bookingData.amount) || 0;
    let rawFee = (amount * 2) / 100; // backend default when the tenant has no fee configuration
    if (this.tenantFees) {
      const feeValue = Number(this.tenantFees.singleEndUserFee) || 0;
      switch ((this.tenantFees.singleEndUserFeeType || '').toLowerCase()) {
        case 'percentage':
        case '%':
          rawFee = (amount * feeValue) / 100;
          break;
        case 'absolute':
          rawFee = feeValue;
          break;
        default:
          rawFee = 0;
      }
    }
    // Floor to 1 decimal place to match the backend fee rounding.
    return Math.floor(rawFee * 10) / 10;
  }

  getFlexiblePayableTotal(): number {
    return Math.round(((Number(this.bookingData.amount) || 0) + this.getFlexiblePlatformFee()) * 100) / 100;
  }

  private loadTenantFees(tenantId) {
    if (!tenantId) {
      return;
    }
    this.authService.getTenantFeeById(tenantId).subscribe(
      (response: any) => this.tenantFees = response,
      (error) => console.log("Error while retrieving tenant fees", error)
    );
  }

  /**
   * Flexible "Pay Now": one call to the BillDesk initiate endpoint creates the booking (WaitingForPayment)
   * and starts the transaction, then the BillDesk gateway is launched (same as the slot "Pay Now" flow).
   */
  private bookOpenProductWithPayNow(data: any, form: NgForm) {
    const request = {
      bookingRequest: [data],
      browserInfo: this.utilService.getBrowserDetails(),
      discountType: null,
      discountValue: null
    };
    this.bookNowDisabled = true;
    this.authService.initiateBillDeskPayment(request).subscribe(
      (payResponse: any) => {
        const config = {
          responseHandler: (txn) => {
            console.log("BillDesk callback status:: ", txn.status);
            if (txn.status === 111 || txn.terminal_state === 111) {
              const terminationStatus = txn.status === 111 ? txn.status : txn.terminal_state;
              this.authService.terminateBillDeskTransaction(terminationStatus, payResponse.orderId)
                .pipe(finalize(() => {
                  // The BillDesk SDK calls this outside Angular's zone; reload inside NgZone so the UI refreshes.
                  this.ngZone.run(() => this.adminBookingSvc.reloadData.next({ reloadData: true }));
                }))
                .subscribe(
                  (res: any) => console.log('terminate response', res),
                  (err: any) => console.log('terminate settled (303 redirect expected)', err)
                );
            }
          },
          merchantLogo: "/assets/img/Logo.svg",
          flowConfig: this.utilService.billDeskFlowConfig(payResponse),
          flowType: "payments"
        };
        // Admin-initiated payment: the payment-status page redirects back to admin bookings on success.
        this.authService.setStoredItem(AppConstants.SESSION_STORAGE_PAYMENT_SOURCE, AppConstants.PAYMENT_SOURCE_ADMIN_BOOKING);
        if (typeof (window as any).loadBillDeskSdk !== 'function') {
          this.bookNowDisabled = false;
          alert("Payment gateway is still loading. Please try again in a few seconds.");
          return;
        }
        this.utilService.launchBillDeskSdk(config);
        this.resetFormDefaults(form);
        this.showFlexibleForm = false;
        this.bookNowDisabled = false;
      },
      (error: any) => {
        this.bookNowDisabled = false;
        console.log('Error initiating BillDesk payment' + JSON.stringify(error));
        if (error.error && error.error[0] && error.error[0].bookingStatus === 'Unavailable') {
          alert("Selected slot is unavailable");
        } else {
          alert("Payment gateway failed. Please try again or after some time!!!!");
        }
      }
    );
  }

  bookNowOpenProduct(form: NgForm) {
    if (form.valid) {
      console.log('Form info:', this.bookingData);
      let data = JSON.parse(JSON.stringify(this.bookingData));
      // The backend reads phoneNumber (not phone); without it the admin's phone was stored on the booking.
      data.phoneNumber = this.bookingData.phone;
      const endDate = new Date(data.startDate);
      endDate.setMonth(endDate.getMonth() + data.months);
      // Format endDate as 'YYYY-MM-DD'
      const formattedEndDate = endDate.toISOString().split('T')[0];
      data.endDate = formattedEndDate;
      data.amount = Number(data.amount);
      data.uniqueId = this.user.tenantId + "_" + this.selectedProduct.id + "_" + data.startDate
                    + "_" + this.convertTo24Hr(data.startTime) + "_" + this.convertTo24Hr(data.endTime) + "_" +
                    this.bookingData.venue;
      const generatePaymentLink = this.paymentMethod === 'sendLink';
      let expiryDuration = -1;
      if (generatePaymentLink && this.paymentOption === 'within') {
        expiryDuration = (Number(this.expiryInDays) * 24 * 60) + Number(this.expiryInMin);
      }
      const payNow = this.paymentMethod === 'payNow';
      data.paymentType = (generatePaymentLink || payNow) ? "Billdesk" : "Cash";
      data.name = this.bookingData.firstName + " " + this.bookingData.lastName;
      console.log(data.uniqueId);

      if (payNow) {
        this.bookOpenProductWithPayNow(data, form);
        return;
      }

      let arrayJSon = [data];
      // Cash only: record it as already "Paid" (Booked) or "WaitingForPayment" (mark as paid later).
      const cashPaymentStatus = this.paymentMethod === 'cash' ? this.cashPaymentStatus : null;
      //console.log("Open Product payload", arrayJSon);
      this.authService.confirmBooking(arrayJSon, generatePaymentLink, expiryDuration, cashPaymentStatus).subscribe(
        (response: any) => {
          console.log("Booking is successful, response: ", response);
          const confirmationId = response.confirmationId;
          this.adminBookingSvc.reloadData.next({
            confirmationId: response.confirmationId,
            reloadData: true
          });
          this.resetFormDefaults(form);
          this.showFlexibleForm = false;
        },
        (error) => {
          console.log("Booking failed, response: ", error);
        }
      );

    } else {
      console.log('Form is invalid');
    }
  }

  showFlexibleForm = false;

  showFlexiForm() {
    //console.log("Venues ", this.venues);
    //console.log("PID ", this.selectedProduct.id);
    this.venuesOfSelectedProduct = this.getVenuesByProductId(this.venues, this.selectedProduct.id);
    //console.log("VPID ", this.venuesOfSelectedProduct);

    /* setTimeout(() => {
        this.resetFormDefaults(this.formRef);
      }, 200); */
    this.showFlexibleForm = true;
    setTimeout(() => this.formRef && this.resetFormDefaults(this.formRef), 0);
  }

  resetFormDefaults(form) {
   form.resetForm({
      venue: this.venues.length > 0 ? this.venues[0].id : '',
      startTime: null,
      endTime: null,
      startDate: new Date().toISOString().split('T')[0],
      months: 1,
      amount: 0,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      notes: '',
      selectedDays: [],
      paymentMethod: 'cash',
      paymentOption: 'anytime',
      expiryInDays: '0',
      expiryInMin: '30'
    });
    this.paymentMethod = 'cash';
    this.paymentOption = 'anytime';
    this.cashPaymentStatus = 'Paid';
    this.expiryInDays = '0';
    this.expiryInMin = '30';
  }

  startTimeOptions = [];
  endTimeOptions = [];
  filteredEndTimeOptions = [];
  zeros = 0;
  thirty = 30;
  dateObj = new Date();

  generateTimeOptions() {
    if (!this?.selectedProduct?.durationPerSlot) {
      return;
    }
    let duration = this.selectedProduct.durationPerSlot;
    this.startTimeOptions = [];
    this.endTimeOptions = [];

    const totalMinutesInDay = 24 * 60;
    const date = new Date();

    for (let minutes = 0; minutes < totalMinutesInDay; minutes += duration) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      const time = this.datePipe.transform(date.setHours(hours, mins, 0, 0), 'h:mm a');

      if (time) {
        this.startTimeOptions.push(time);
        this.endTimeOptions.push(time);
        this.allTimes.push({ minutesFromMidnight: minutes, label: time });
      }
    }
  }



  getAllVenuesByTenantId(tenantId) {
    this.isLoading = true;
    this.venuesSubscription = this.authService.getAllVenuesByTenantId(tenantId).subscribe(
      (response: any) => {
        this.venues = [];
        if (response && response.length > 0) {
          response.forEach((venue) => {
            this.venues.push({
              id: venue.id,
              name: venue.venueName,
              productIds: venue.productIds
            });
          });
          this.getAllProductsByTenantId(this.user.tenantId);
        } else {
          this.isLoading = false;
        }
      },
      (error) => {
        console.log('getAllVenuesByTenantId - ' + JSON.stringify(error));
        this.isLoading = false;
      }
    )
  }

getAllProductsByTenantId(tenantId: number) {
  this.isLoading = true;
  this.productsSubscription = this.authService.getAllProductsByTenantId(tenantId, true).subscribe(
    (response: any[]) => {
      this.products = [];
      console.log('Get All Products ByTenantId');

      if (Array.isArray(response) && response.length > 0) {
        // keep current selection (if any) to restore after sort
        const prevSelectedName = this.selectedProductName;

        this.products = response.map((product: any): ProductWithSlots => {
          const sessions: SessionWithSlots[] = (product.sessions || []).map((s: any) => {
            const timeslots: TimeSlot[] = (s.timeslotWiseProduct || []).map((t: any) => ({
              id: t.id,
              venueId: t.venueId,
              tenantId: t.tenantId,
              startTime: t.startTime,
              endTime: t.endTime,
              price: t.price,
              productId: t.productId,
              sessionId: t.sessionId,
              createdAt: t.createdAt,
              updatedAt: t.updatedAt,
            }));
            return { ...s, timeslots };
          });

          const timeslots: TimeSlot[] = ([] as TimeSlot[]).concat(...sessions.map(s => s.timeslots || []));

          return {
            id: product.id,
            name: product.productName,
            description: product.description,
            type: product.productType,
            durationPerSlot: product.durationPerSlot,
            sessionType: product.sessionType,
            noOfSessions: product.noOfSessions,
            monthlyMultiBookingOption: product.monthlyMultiBookingOption,
            monthlyMultiBookingSelectedDates: product.monthlyMultiBookingSelectedDates,
            capacityPerVenue: product.capacityPerVenue,
            sessions,
            timeslots,
            price: product.price
          };
        });

        // ✅ Sort alphabetically A→Z (case-insensitive, numeric-aware)
        this.products.sort((a, b) =>
          (a?.name ?? '').trim().localeCompare((b?.name ?? '').trim(), undefined, {
            sensitivity: 'base',
            numeric: true,
          })
        );

        // A productId passed via the route (e.g. after an admin Pay Now) wins; otherwise keep the
        // previously selected product if it still exists after sorting. Both fall back to the first.
        const preselected = this.preselectProductId != null
          ? this.products.find(p => Number(p.id) === this.preselectProductId)
          : undefined;
        // One-shot: don't let the route selection stick across later reloads.
        this.preselectProductId = null;

        const found = preselected ?? (prevSelectedName
          ? this.products.find(p => p.name === prevSelectedName)
          : undefined);

        this.selectedProduct = found ?? this.products[0];
        this.selectedProductName = this.selectedProduct?.name;
        this.selectedProductPrice = this.selectedProduct?.price;
        this.selectedServiceType = this.selectedProduct?.type;
        this.sessionType = this.selectedProduct?.sessionType;
        this.monthlyMultiBookingOption = this.selectedProduct?.monthlyMultiBookingOption;
        this.monthlyMultiBookingSelectedDates = this.selectedProduct?.monthlyMultiBookingSelectedDates;

        //console.log('Pushed Products (sorted A→Z):');
        //console.log('SelectedServiceType', this.selectedServiceType);
        //console.log('SessionType', this.sessionType);
        //console.log('monthlyMultiBookingOption', this.monthlyMultiBookingOption);
        //console.log('monthlyMultiBookingSelectedDates', this.monthlyMultiBookingSelectedDates);

        this.onProductChanged();
      }
      this.isLoading = false;
    },
    (error: any) => {
      console.log('getAllProductsByTenantId - ' + JSON.stringify(error));
      this.isLoading = false;
    }
  );
}


 /*  getAllProductsByTenantId(tenantId: number) {
    this.productsSubscription = this.authService.getAllProductsByTenantId(tenantId).subscribe(
      (response: any[]) => {
        this.products = [];
        console.log(" getAllProductsByTenantId All Products: ", response);

        if (Array.isArray(response) && response.length > 0) {
          this.products = response.map((product: any): ProductWithSlots => {
            const sessions: SessionWithSlots[] = (product.sessions || []).map((s: any) => {
              const timeslots: TimeSlot[] = (s.timeslotWiseProduct || []).map((t: any) => ({
                id: t.id,
                venueId: t.venueId,
                tenantId: t.tenantId,
                startTime: t.startTime,
                endTime: t.endTime,
                price: t.price,
                productId: t.productId,
                sessionId: t.sessionId,
                createdAt: t.createdAt,
                updatedAt: t.updatedAt,
              }));

            // 👉 Sort alphabetically A→Z (case-insensitive, numeric-aware)
            this.products.sort((a, b) =>
              (a?.name ?? '').trim().localeCompare((b?.name ?? '').trim(), undefined, {
                sensitivity: 'base',
                numeric: true,
              })
            );

              return { ...s, timeslots };
            });


            const timeslots: TimeSlot[] = [].concat(...sessions.map(s => s.timeslots || []));

            return {
              id: product.id,
              name: product.productName,
              type: product.productType,
              durationPerSlot: product.durationPerSlot,
              sessionType: product.sessionType,
              noOfSessions: product.noOfSessions,
              monthlyMultiBookingOption: product.monthlyMultiBookingOption,
              monthlyMultiBookingSelectedDates: product.monthlyMultiBookingSelectedDates,
              capacityPerVenue: product.capacityPerVenue,
              sessions,
              timeslots,
              price: product.price
            };
          });

          this.selectedProduct = this.products[0];
          this.selectedProductName = this.selectedProduct.name;
          this.selectedProductPrice = this.selectedProduct.price;
          this.selectedServiceType = this.selectedProduct.type;
          this.sessionType = this.selectedProduct.sessionType;
          this.monthlyMultiBookingOption = this.selectedProduct.monthlyMultiBookingOption;
          this.monthlyMultiBookingSelectedDates = this.selectedProduct.monthlyMultiBookingSelectedDates;

          console.log("Pushed Products", this.products );
          console.log("SelectedServiceType", this.selectedServiceType);
          console.log("SessionType", this.sessionType);
          console.log("monthlyMultiBookingOption", this.monthlyMultiBookingOption);
          console.log("monthlyMultiBookingSelectedDates", this.monthlyMultiBookingSelectedDates);

          this.onProductChanged();
        }
      },
      (error: any) => {
        console.log('getAllProductsByTenantId - ' + JSON.stringify(error));
      }
    );
  }
 */
  get sortedProducts() {
    // returns a new, alphabetically sorted array (case-insensitive, numeric-aware)
    return [...(this.products || [])].sort((a, b) =>
      (a?.name ?? '').trim().localeCompare((b?.name ?? '').trim(), undefined, {
        sensitivity: 'base',
        numeric: true
      })
    );
  }

//   /* getAllProductsByTenantId(tenantId) {
//     this.productsSubscription = this.authService.getAllProductsByTenantId(tenantId).subscribe(
//       (response: any) => {
//         this.products = [];
//         console.log("All Products: ", response);
//         if (response && response.length > 0) {
//           response.forEach((product) => {
//             this.products.push({
//               id: product.id,
//               name: product.productName,
//               type: product.productType,
//               durationPerSlot: product.durationPerSlot,
//               sessionType: product.sessionType,
//               noOfSessions: product.noOfSessions,
//               monthlyMultiBookingOption: product.monthlyMultiBookingOption,
//               monthlyMultiBookingSelectedDates: product.monthlyMultiBookingSelectedDates,
//               capacityPerVenue: product.capacityPerVenue,
//               sessions: product.sessions,
//               price: product.price
//             });
//           });
//           this.selectedProduct = this.products[0];
//           this.selectedProductName = this.selectedProduct.name;
//           this.selectedServiceType = this.selectedProduct.type;
//           this.sessionType = this.selectedProduct.sessionType;
//           this.monthlyMultiBookingOption = this.selectedProduct.monthlyMultiBookingOption;
//           this.monthlyMultiBookingSelectedDates = this.selectedProduct.monthlyMultiBookingSelectedDates;
//           console.log("SelectedServiceType", this.selectedServiceType);
//           console.log("SessionType", this.sessionType);
//           console.log("monthlyMultiBookingOption", this.monthlyMultiBookingOption);
//           console.log("monthlyMultiBookingSelectedDates", this.monthlyMultiBookingSelectedDates);
//           this.onProductChanged();
//         }
//       },
//       (error) => {
//         console.log('getAllProductsByTenantId - ' + JSON.stringify(error));
//       }
//     )
//   } */

  getCurrentDate() {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    let month: any = currentDate.getMonth() + 1;
    let date: any = currentDate.getDate();
    if (month < 10) {
      month = '0' + month;
    }
    if (date < 10) {
      date = '0' + date;
    }
    return year + '-' + month + '-' + date;
  }

  /* onDateChange(selectedDate) {
    console.log(selectedDate);
    const dateSelected = selectedDate.split('-');
    const date = new Date();
    date.setDate(dateSelected[2]);
    date.setMonth(parseInt(dateSelected[1], 10) - 1);
    date.setFullYear(dateSelected[0]);
    this.selectedDate = date;
    console.log("Selected Date", this.selectedDate);
  } */

  onDateChange(selectedDate) {
    console.log(selectedDate);

    const [year, month, day] = selectedDate.split('-').map(Number);

    this.selectedDate = new Date(year, month - 1, day);

    console.log("Selected Date", this.selectedDate);
  }


  onMultiSessionServiceStartDateChange(startDate: string) {
    //console.log('Selected session count:', startDate);
    this.selectedStartDate = startDate;
    console.log('selected service StartDate selected dates', this.selectedStartDate);
    this.adminBookingSvc.updateServiceStartDate(this.selectedStartDate, this.selectedServiceType, this.monthlyMultiBookingOption, this.sessionType);
    // Handle the change in session count as needed
  }
  onDateChange_MultiSessionSelectAnyDay(selectedDate) {
    console.log('selected Service StartDate Start Any Day', this.selectedStartDate);
    this.adminBookingSvc.updateServiceStartDate(selectedDate, this.selectedServiceType, this.monthlyMultiBookingOption, this.sessionType);
  }

  clearDate() {
    this.toDate = '';
    console.log("Clear Date");
  }
  convertStringToNumberArray(input: string): number[] {
    if (!input) {
      return [];
    }

    // Split the string by commas, trim any extra spaces, and convert to numbers
    return input
      .split(',')
      .map(item => item.trim()) // Remove extra spaces around the numbers
      .map(Number) // Convert to number
      .filter(value => !isNaN(value)); // Filter out any invalid numbers
  }

  resetSelections() {
      this.selectedDateStr = '';
      this.selectedStartDate = '';
      this.selectedTime = [];
      this.selectedVenueId = null;
    }

  onProductChanged() {
    this.selectedProduct = null;
    this.resetSelections();   // clear old selections
    this.selectedStartDate = this.latest_date1;
    setTimeout(() => this.changeDetect.detectChanges());
    console.log('selected product name - ' + this.selectedProductName);
    this.selectedProduct = this.products.find(product => product.name === this.selectedProductName);
    this.selectedProductName = this.selectedProduct.name;
    this.selectedProductPrice = this.selectedProduct.price;
    this.selectedServiceType = this.selectedProduct.type;
    this.addOnError = '';
    if (this.isAddOnSelected) {
      this.sessionType = null;
      this.showFlexibleForm = false;
      this.venuesForSelectedProduct = [];
      this.monthlyMultiBookingSelectedDates = [];
      return;
    }
    this.sessionType = this.selectedProduct.sessionType;
    this.monthlyMultiBookingOption = this.selectedProduct.monthlyMultiBookingOption;
    this.monthlyMultiBookingSelectedDates = this.convertStringToNumberArray(this.selectedProduct.monthlyMultiBookingSelectedDates);
    if(this.sessionType === 'Flexible') {
      setTimeout(() => {
        this.resetFormDefaults(this.formRef);
      }, 200);
      this.generateTimeOptions();
      this.updateEndTimeOption();
      this.showFlexibleForm = false;
    }


    //console.log("OPC :", this.selectedProduct);

    //console.log("SelectedServiceType", this.selectedServiceType);
    //console.log("SessionType", this.sessionType);
    //console.log("monthlyMultiBookingOption", this.monthlyMultiBookingOption);
    //console.log("monthlyMultiBookingSelectedDates", this.monthlyMultiBookingSelectedDates);


    if (this.selectedServiceType == "Multi Session") {
      //this.monthlyMultiBookingOption = this.products[this.selectedProductIndex].monthlyMultiBookingOption

      if (this.monthlyMultiBookingOption === "Selected Dates") {
        //this.monthlyMultiBookingSelectedDates = this.parseSelectedDates(this.products[this.selectedProductIndex].monthlyMultiBookingSelectedDates);
        console.log("selected dates", this.monthlyMultiBookingSelectedDates);
        this.generateFutureDates();
      }
      else if (this.monthlyMultiBookingOption === "Start Any Day") {
        this.adminBookingSvc.updateServiceStartDate(this.latest_date1, this.selectedServiceType, this.monthlyMultiBookingOption, this.sessionType);
      }
      else {
        this.monthlyMultiBookingSelectedDates.length = 0; //clear the array for other product types
        //this.selectedStartDate = null;
      }
      //console.log("MM Settings1 : ", this.monthlyMultiBookingOption);
      //console.log("MM Settings2 : ", this.monthlyMultiBookingSelectedDates);

    }
    else {
      this.selectedStartDate = null;
    }

    this.venuesForSelectedProduct = this.venues.filter((venue) => venue.productIds.indexOf(this.selectedProduct.id) > -1);
  }
  totalSessions = 0;

  calculatePrice() {

    let matchingDays = 0;
    this.bookingData.amount = 0;
    this.totalSessions = 0;
    console.log("Calculate price called.");
    console.log(this.bookingData);
     console.log("Book noe status CP", this.bookNowDisabled);

    const { startDate, selectedDays, months, startTime, endTime } = this.bookingData;
    const pricePerSession = this.selectedProduct.price;
    const durationPerSlot = this.selectedProduct.durationPerSlot; // in minutes

    //this.updateEndTimeOption();

    console.log("End Time",  endTime);

    if (startDate && selectedDays?.length > 0 && months && startTime && endTime) {
      console.log("All info present");

      const start = new Date(startDate);
      const end = new Date(start);
      end.setMonth(end.getMonth() + months);

      // Convert selectedDays (e.g., ['Monday']) into numeric days (e.g., [1])
      const dayMap = {
        sunday: 0,
        monday: 1,
        tuesday: 2,
        wednesday: 3,
        thursday: 4,
        friday: 5,
        saturday: 6
      };
      const selectedWeekdays = selectedDays.map(day => day.toLowerCase());
      const targetWeekdays: number[] = selectedWeekdays.map(d => dayMap[d]);

      // Calculate session duration in minutes
      const startMinutes = this.convertToMinutes(startTime);
      const endMinutes = this.convertToMinutes(endTime);
      const totalMinutes = endMinutes - startMinutes;

      const slotsPerDay = Math.floor(totalMinutes / durationPerSlot);


      const current = new Date(start);

      while (current < end) {
        if (targetWeekdays.includes(current.getDay())) {
          matchingDays++;
        }
        current.setDate(current.getDate() + 1);
      }

      const totalSessions = matchingDays * slotsPerDay;
      const totalAmount = totalSessions * pricePerSession;

      console.log('Matching Days:', matchingDays);
      console.log('Slots per Day:', slotsPerDay);
      console.log('Total Sessions:', totalSessions);
      console.log('Total Amount:', totalAmount);

      this.totalSessions = totalSessions;
      this.bookingData.amount = totalAmount;
    } else {
      console.log("Missing fields to calculate price.");
    }
  }

  // When user picks an end time, re-enable if valid
  onEndTimeChange(val: string | null) {
    this.bookNowDisabled = !val;   // disabled if null/empty

    console.log("Book noe status EChange", this.bookNowDisabled);
    this.calculatePrice();
  }

  updateEndTimeOption() {
    this.bookingData.endTime = null;
     console.log("Book noe status update end", this.bookNowDisabled);
    const start = this.allTimes.find(t => t.label === this.bookingData.startTime);
    if (!start) {
      this.endTimeOptions = [];
      return;
    }

    // Only times greater than selected start
    this.endTimeOptions = this.allTimes
      .filter(t => t.minutesFromMidnight > start.minutesFromMidnight)
      .map(t => t.label);

      this.bookNowDisabled = true;
  }

  formatTimeToAMPM(time24: string): string {
    const [hour, minute] = time24.split(':').map(Number);
    const date = new Date();
    date.setHours(hour);
    date.setMinutes(minute);
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true
    });
  }
  getFormattedSortedTimeSlots(): string[] {
    if (!this.selectedProduct?.timeslots) return [];

    return this.selectedProduct.timeslots
      .slice()
      .sort((a, b) => a.startTime.localeCompare(b.startTime))  // Sort by startTime
      .map(slot => this.formatTimeToAMPM(slot.startTime));     // Convert to AM/PM
  }

  getUniqueFormattedSortedTimeSlots(): string[] {

    //console.log("getUniqueFormattedSortedTimeSlots", this.selectedProduct);
    if (!this.selectedProduct?.timeslots) return [];

    const unique = new Map<string, string>();
    this.selectedProduct.timeslots.forEach(slot => {
      if (!unique.has(slot.startTime)) {
        unique.set(slot.startTime, this.formatTimeToAMPM(slot.startTime));
      }
    });

    return Array.from(unique.keys())
      .sort((a, b) => {
        const [ah, am] = a.split(':').map(Number);
        const [bh, bm] = b.split(':').map(Number);
        return ah * 60 + am - (bh * 60 + bm);
      })
      .map(time => this.formatTimeToAMPM(time));
  }

  onTimeToggle(time: string) {
    const index = this.selectedTime.indexOf(time);
    if (index === -1) {
      this.selectedTime.push(time);
    } else {
      this.selectedTime.splice(index, 1);
    }
  }



  convertToMinutes(timeStr: string): number {
    const [time, modifier] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier === 'PM' && hours !== 12) {
      hours += 12;
    }
    if (modifier === 'AM' && hours === 12) {
      hours = 0;
    }

    return hours * 60 + minutes;
  }

  cancelFlexibleBooking(): void {
    this.bookingData = {
      venue: null,
      startDate: null,
      selectedDays: [],
      months: 1,
      startTime: null,
      endTime: null,
      amount: 0,
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      notes: ''
    };
    this.showFlexibleForm = false;
    this.bookNowDisabled = true;
    this.endTimeOptions = [];
  }


  generateFutureDates(): void {
    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth(); // 0-indexed month
    const monthsToGenerate = 2; // Generate dates for the next 2 months
    this.futureDates.length = 0;
    // Loop through the current and next month
    for (let i = 0; i < monthsToGenerate; i++) {
      const month = currentMonth + i; // Calculate the month
      const year = currentYear + Math.floor(month / 12); // Handle year rollover
      const actualMonth = month % 12; // Adjust month to stay within 0-11 range

      // Loop through each day in X
      if (Array.isArray(this.monthlyMultiBookingSelectedDates)) {
        this.monthlyMultiBookingSelectedDates.forEach(day => {
          // Your logic here
          //console.log("Day", day);
          if (day > 0 && day <= this.daysInMonth(actualMonth, year)) {
            const date1 = new Date(year, actualMonth, day);
            //console.log("Day", date1);
            if (date1 > today) {
              this.futureDates.push(date1.toLocaleDateString('en-CA')); // Store as 'YYYY-MM-DD'
            }
          }
        });
      } else {
        console.error('monthlyMultiBookingSelectedDates is not an array:', this.monthlyMultiBookingSelectedDates);
        this.monthlyMultiBookingSelectedDates = []; // Ensure it's an array to avoid further issues
      }


    }

    if (this.futureDates.length > 0) {
      this.selectedStartDate = this.futureDates[0]; // Default to the first date
      this.adminBookingSvc.updateServiceStartDate(this.selectedStartDate, this.selectedServiceType, this.monthlyMultiBookingOption, this.sessionType);
      console.log("StartDate updated in admin booking service");
    }
    //console.log('Generated Future Dates:', this.futureDates); // Log the dates
  }
  daysInMonth(month: number, year: number): number {
    return new Date(year, month + 1, 0).getDate(); // Get the last day of the month
  }

  getVenuesByProductId(venues: any[], productId: number): { id: number, venueName: string }[] {
    return venues
      .filter(venue => venue.productIds.includes(productId))
      .map(venue => ({ id: venue.id, venueName: venue.name }));
  }
  /* calculateEndTimeFromStart(startTime: string, durationMinutes: number): string {

      console.log("Duration", durationMinutes );
        const [h, m] = startTime.split(':').map(Number);
        const date = new Date();
        date.setHours(h, m + durationMinutes);
        return date.toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: true
        });
  } */
  calculateEndTime(startTime: string, duration: number): string {
    // Parse the 12-hour time string into a Date
    const date = new Date("1970-01-01 " + startTime);

    // Add duration in minutes
    date.setMinutes(date.getMinutes() + duration);

    // Format back to 12-hour time with AM/PM
    return date.toLocaleTimeString("en-US", {
      hour: "numeric",
      minute: "2-digit",
      hour12: true
    });
  }
  bookNow() {
    console.log('book now clicked');
    console.log("Venues", this.venues);
    if (this.isAddOnSelected) {
      this.addSelectedAddOn();
      if (this.addOnError) return;
      this.openCartBooking();
      return;
    }
     this.showFlexibleForm = false;
     if (this.sessionType === 'Monthly') {
        if (!this.selectedTime || this.selectedTime.length === 0) {
          alert('Please select at least one slot before booking.');
          return;
        }

        this.selectedTime.forEach(time => {

          console.log("time", time);
          const endTimeFromDuration = this.calculateEndTime(time, this.selectedProduct.durationPerSlot);
          console.log("End time", endTimeFromDuration);
          const uniqueId = 'Monthly'+ '_' + this.user.tenantId + '_' + this.selectedProduct.id + '_' + this.selectedStartDate + '_' + this.convertTo24Hr(time) + '_' + this.convertTo24Hr(endTimeFromDuration) +  '_' + this.selectedVenueId;
          const selectedVenue = this.venuesOfSelectedProduct.find(v => v.id === this.selectedVenueId);

          const monthlySlotData: MonthlySlotData =
          {
            uniqueId,
            productId: this.selectedProduct.id,
            productName:  this.selectedProductName,
            venueName: selectedVenue ? selectedVenue.venueName : '',
            price: this.selectedSlotPrice || this.selectedProductPrice,
            date: 'date_' +  this.selectedStartDate,
            startTime: this.convertTo24Hr(time),
            endTime: this.convertTo24Hr(endTimeFromDuration)
         };

         console.log("Slot ", monthlySlotData);
          this.adminBookingSvc.addToSelectedSlots(monthlySlotData);
        });

        console.log("Monthly booking confirmed for selected times:", this.selectedTime);
      }

    this.openCartBooking();
  }

  openCartBooking() {
    const selectedSlots = this.adminBookingSvc.getSelectedSlotData();
    if ((!selectedSlots || selectedSlots.length === 0) && this.selectedAddOnsMap.size === 0) {
      alert('Please add a slot or add-on before booking.');
      return;
    }

    const dialogRef = this.dialog.open(BookSelectedSlotsComponent, {

      data: {},
      // Let CSS control most styling, but remove Angular’s 80vw cap
      maxWidth: '100vw',
      // (optional) if you also want edge-to-edge by default
      // width: '100vw',

      // Give us a handle to target on mobile
      panelClass: 'bd-mobile-full',

      autoFocus: false,
      restoreFocus: false

    });
    dialogRef.afterClosed().subscribe(result => {
      this.addOnQuantities = {};
      console.log('Dialog closed');
      // this.adminBookingSvc.clearSelectedSlots();
      this.adminBookingSvc.setReloadPage(true);
      if (result) {
        // handle result if any (optional)
        console.log('Result from dialog:', result);
      }
    });
  }

  onTabSelectionChanged(event) {
    console.log('on tab selection changed event - ' + JSON.stringify(event));
  }

  ngOnDestroy() {
    if (this.venuesSubscription) {
      this.venuesSubscription.unsubscribe();
    }
    if (this.productsSubscription) {
      this.productsSubscription.unsubscribe();
    }
    if (this.reloadDataSubscription) {
      this.reloadDataSubscription.unsubscribe();
    }
  }
  openBulkBooking() {

    const venueCount =
      this.venues.filter(
        x => x.productIds &&
             x.productIds.indexOf(
               this.selectedProduct.id
             ) > -1
      ).length;

    if (venueCount === 0) {

      alert(
        'No venues are attached to this service. Please attach at least one venue before using Bulk Booking.'
      );

      return;

    }

    this.dialog.open(
      BulkBookingsComponent,
      {
        width: '700px',
        maxWidth: '95vw',
        maxHeight: '95vh',
        autoFocus: false,
        restoreFocus: false
      });

  }
 /*  openBulkBooking() {

    this.dialog.open(
      BulkBookingsComponent,
      {
        width: '700px',
        maxWidth: '95vw',
        maxHeight: '95vh',
        autoFocus: false,
        restoreFocus: false
      });

  } */

}
